const data = [
  {
    image: "https://via.placeholder.com/150",
    name: "압력밥솥",
    price: "10,000원",
    location: "세종시 고운동",
    interest: 15,
    chat: 41,
  },
  {
    image: "https://via.placeholder.com/150",
    name: "토마토",
    price: "100,000원",
    location: "경기도 부천시 중1동",
    interest: 35,
    chat: 58,
  },
  {
    image: "https://via.placeholder.com/150",
    name: "프라다 백팩팝니다",
    price: "40,000원",
    location: "서울 송파구 잠실동",
    interest: 11,
    chat: 46,
  },
  {
    image: "https://via.placeholder.com/150",
    name: "자전거",
    price: "10,000원",
    location: "세종시 고운동",
    interest: 15,
    chat: 41,
  },
  {
    image: "https://via.placeholder.com/150",
    name: "아이패드 5세대",
    price: "100,000원",
    location: "경기도 부천시 중1동",
    interest: 35,
    chat: 58,
  },
  {
    image: "https://via.placeholder.com/150",
    name: "스트라이더 밸런스바이크",
    price: "40,000원",
    location: "서울 송파구 잠실동",
    interest: 11,
    chat: 46,
  },
  {
    image: "https://via.placeholder.com/150",
    name: "컴퓨터 팔아요",
    price: "10,000원",
    location: "세종시 고운동",
    interest: 15,
    chat: 41,
  },
  {
    image: "https://via.placeholder.com/150",
    name: "기프트",
    price: "100,000원",
    location: "경기도 부천시 중1동",
    interest: 35,
    chat: 58,
  },
  {
    image: "https://via.placeholder.com/150",
    name: "스트라이더 밸런스바이크",
    price: "40,000원",
    location: "서울 송파구 잠실동",
    interest: 11,
    chat: 46,
  },
  {
    image: "https://via.placeholder.com/150",
    name: "스트라이더 밸런스바이크",
    price: "40,000원",
    location: "서울 송파구 잠실동",
    interest: 11,
    chat: 46,
  },
];

export default data;
